import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedFeaturePageLayoutModule } from '@shared/feature/page-layout';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { SharedFeatureTranslateModule } from '@shared/feature/translate';
import { SharedUiModalModule } from '@shared/ui/modal';
import { SharedUiInputsModule } from '@shared/ui/inputs';
import { ChangePasswordDialogComponent } from './components/change-password-dialog/change-password-dialog.component';
import { SharedUiButtonsModule } from '@shared/ui/buttons';
import { ReactiveFormsModule } from '@angular/forms';
import { IntrensicSharedOfficerDetailsModule } from '@intrensic/shared/officer-details';
import { ChangePinDialogComponent } from './components/change-pin-dialog/change-pin-dialog.component';
import { ChangeProfileDialogComponent } from './components/change-profile-dialog/change-profile-dialog.component';
import { SharedFeatureFormsModule } from '@shared/feature/forms';
import { DownloadEvidenceDialogComponent } from './components/download-evidence-dialog/download-evidence-dialog.component';
import { DownloadAllEvidenceDialogComponent } from './components/download-all-evidence-dialog/download-all-evidence-dialog.component';
import { SharedUiDrawerModule } from '@shared/ui/drawer';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedFeaturePageLayoutModule,
    SharedUiIconsModule,
    SharedFeatureTranslateModule,
    SharedUiButtonsModule,
    SharedUiModalModule,
    ReactiveFormsModule,
    IntrensicSharedOfficerDetailsModule,
    SharedUiInputsModule,
    SharedFeatureFormsModule,
    SharedUiDrawerModule,
  ],
  exports: [ChangePinDialogComponent, ChangePasswordDialogComponent, ChangeProfileDialogComponent, DownloadEvidenceDialogComponent],
  declarations: [ChangePinDialogComponent, ChangePasswordDialogComponent, ChangeProfileDialogComponent, DownloadEvidenceDialogComponent, DownloadAllEvidenceDialogComponent],
})
export class IntrensicSharedLayoutModule {}
